module.exports = {
  layout: 'sidemenu',
  fixedHeader: true, // sticky header
  autoHideHeader: false, // auto hide header
  fixedSidebar: true, // sticky siderbar
  siderWidth: 280,
  title: 'Luminia',
  timeOutMinutes: 1440,
};
